export enum FilterType {
	Category = "categorySeed",
	Pricelist = "flagSeed",
	Flag = "pricelistSeed"
}
